import { isAxiosError } from "axios";
import axiosInstance from "../../utility/axiosInstance";

// types and state
import {
  setDegree,
  updateDegree,
  deleteDegree,
  setLoading,
} from "../../store/slices/degree";
import { openNotification } from "../../components/ui/alerts";

export const get_degrees = async (dispatch: Function) => {
  dispatch(setLoading());
  try {
    const response = await axiosInstance.get("/get-degrees");

    dispatch(setDegree(response.data));
  } catch (error) {
    dispatch(setDegree([]));
  }
  dispatch(setLoading());
};

export const create_degree = async (
  dispatch: Function,
  data: { name: string },
) => {
  dispatch(setLoading());
  try {
    const response = await axiosInstance.post("/create-degree", data);

    dispatch(updateDegree(response.data?.data));
  } catch (error) {
    // dispatch(setRole([]));
  }
  dispatch(setLoading());
};

export const delete_degree = async (
  dispatch: Function,
  id: string | number,
) => {
  dispatch(setLoading());
  try {
    const response = await axiosInstance.delete(`/delete-degree/${id}`);

    dispatch(deleteDegree(id));
    openNotification({
      message: response?.data?.message || "Degree deleted successfully",
      status: "success",
    });
  } catch (error) {
    if (isAxiosError(error)) {
      openNotification({
        message: error?.response?.data?.message || "Failed to delete degree",
        status: "error",
      });
    }
  }
  dispatch(setLoading());
};
